export default __webpack_public_path__ + "static/media/cricket-pitch-responsive.083d521b.png";